var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcVisibilityOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 733 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 366.5,
    cy: 250,
    r: 99.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M366.5,0C204.88,0,59,99.53,0,250,59,400.47,204.88,500,366.5,500S674,400.47,733,250C674,99.53,528.12,0,366.5,0Zm-.25,416.09A166.09,166.09,0,1,1,532.34,250,166.09,166.09,0,0,1,366.25,416.09Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVisibilityOn);
export default __webpack_public_path__ + "static/media/ic_visibility_on.b7ef2a5d60f248d69f961b07da8b2582.svg";
export { ForwardRef as ReactComponent };